import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";


import Rep_OPDReports from "../../HospitalPages/ReportsandAnalytics/Rep_OPDReports";
import Rep_IPDReports from "../../HospitalPages/ReportsandAnalytics/Rep_IPDReports";
import Rep_PharmacySalesReports from "../../HospitalPages/ReportsandAnalytics/Rep_PharmacySalesReports";
import Rep_RadiologyLabReports from "../../HospitalPages/ReportsandAnalytics/Rep_RadiologyLabReports";
import Rep_AccountsReports from "../../HospitalPages/ReportsandAnalytics/Rep_AccountsReports";
import Rep_DoctorPerformanceReports from "../../HospitalPages/ReportsandAnalytics/Rep_DoctorPerformanceReports";
import Rep_BedOccupancyTrends from "../../HospitalPages/ReportsandAnalytics/Rep_BedOccupancyTrends";
import DashboardCards from "../HospitalDashBoardCards";
import { decrypt } from "../../components/cryptoUtil";
import { includeCardForRoles, ROLES } from "../componenet/heading";


const ReportsAndAnalycisDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";


    const userRole = decryptedData.userrole || "";

const cardRoles = {
  "OPD Reports Analytics": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "IPD Reports Analytics": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Pharmacy Sales Reports": [ROLES.RECEPTIONIST],
  "Radiology/Lab Reports": [ROLES.STAFF],
  "Accounts Reports": [ROLES.ACCOUNTSECTION],
  "Doctor Performance Reports": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
   "Bed Occupancy Trends": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
   
};


  const cards = [
     ...includeCardForRoles(cardRoles["OPD Reports Analytics"], userRole,{
      title: "OPD Reports Analytics",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <Rep_OPDReports />,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),
     ...includeCardForRoles(cardRoles["IPD Reports Analytics"], userRole,{
      title: "IPD Reports Analytics",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <Rep_IPDReports />,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),
   
     ...includeCardForRoles(cardRoles["Pharmacy Sales Reports"], userRole,{
      title: "Pharmacy Sales Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <Rep_PharmacySalesReports />,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),
     ...includeCardForRoles(cardRoles["Radiology/Lab Reports"], userRole,{
      title: "Radiology/Lab Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <Rep_RadiologyLabReports />,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),

      ...includeCardForRoles(cardRoles["Accounts Reports"], userRole,{
      title: "Accounts Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <Rep_AccountsReports />,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),

     ...includeCardForRoles(cardRoles["Doctor Performance Reports"], userRole,{
      title: "Doctor Performance Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <Rep_DoctorPerformanceReports />,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),

 ...includeCardForRoles(cardRoles["Bed Occupancy Trends"], userRole,{
      title: "Bed Occupancy Trends",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <Rep_BedOccupancyTrends /> ,category: "👨‍⚕️ Reports And Analycis  Data Management",
    }),


  ];

  
  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
            👨‍⚕️ Reports And Analycis  Data Management
          </Typography>
        }
      />
    );
  };

export default ReportsAndAnalycisDashBoard;
